import React, { Component } from 'react';
import { logModalView } from '../../services/ga';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { withStyles } from '@mui/styles';

const styles = theme => ({
  text: {
    whiteSpace: 'pre-wrap'
  }
});

class UnderDevelopmentModal extends Component {
  componentDidMount() {}

  UNSAFE_componentWillUpdate(props) {
    if (props.show && !this.props.show) {
      logModalView('UnderDevelopmentModal');
    }
  }

  render() {
    let title = "This feature is currently under development";

    const centre = "It will be available soon - we'll let you know when it's ready!";

    return (
      <Dialog open={Boolean(this.props.show)} onClose={this.props.onHide} maxWidth="sm" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText className={this.props.classes.text}>{centre}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onHide} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(UnderDevelopmentModal);

